import React, { useCallback } from 'react'
import { IComboBox, IComboBoxOption, Panel, PanelType, TextField, Toggle } from '@fluentui/react'
import { IOpenPanel } from '../../../../interfaces/base/IPanel'
import { PanelHeader } from '../../../../components/PanelHeader/PanelHeader';
import { PanelFooter } from '../../../../components/PanelFooter/PanelFooter';
import { UseRosterCrear } from './UseRosterCrear';
import { MessageBarResponse } from '../../../../components/MessageBar/MessageBarResponse';
import { ProgressBarLoading } from '../../../../components/ProgressBarLoading/ProgressBarLoading';
import { UseComboGuardiaProgramacion } from '../../../../hooks/combos/UseComboGuardiaProgramacion';
import { ComboBoxBase } from '../../../../components/comboBoxComponent/ComboBoxBase';
import { Switch } from '@fluentui/react-switch';
import { FluentProvider, Label, webLightTheme } from '@fluentui/react-components';
import "./StyleSwitch.css";

const PanelRosterCrear = (props: IOpenPanel) => {

    const { command, setCommand, postInsertarRoster, loading, setLoading, disableForm, cerrarPanel, mensaje, setMensaje, status, buttonSalir } = UseRosterCrear(props);
    const { dataComboGuardiaProgramacion, onClickComboGuardiaProgramacion, _onkeyUpSearchGuardiaProgramacion, comboBoxRefGuardiaProgramacion, filter } = UseComboGuardiaProgramacion(props.isOpen);
    // const { access } = useContext(AuthContext);

    const [turnoDiaChecked, setTurnoDiaChecked] = React.useState(false);
    const [turnoNocheChecked, setTurnoNocheChecked] = React.useState(false);

    const onChangeCombo = (event: React.FormEvent<IComboBox>, option?: IComboBoxOption, type?: string) => {
        if (event != undefined) {
            if (option != undefined) {
                switch (type) {
                    case 'guardia':
                        setCommand({
                            ...command,
                            guardiaProgramacionId: option.key.toString(),
                        });
                        break;
                    default:
                        break;
                }
            }
        }
    }

    const onChangeSwitchTurnoDia = useCallback(
        (ev) => {
            setTurnoDiaChecked(ev.target.checked);
            setCommand({
                ...command,
                dia: ev.target.checked,
            });
        },
        [turnoDiaChecked, command]
    );

    const onChangeSwitchTurnoNoche = useCallback(
        (ev) => {
            setTurnoNocheChecked(ev.target.checked);
            setCommand({
                ...command,
                noche: ev.target.checked,
            });
        },
        [turnoNocheChecked, command]
    );

    const _onChangeToggle = (
        type: string,
        ev: React.MouseEvent<HTMLElement>,
        checked?: boolean
    ) => {
        if (checked != undefined) {
            switch (type) {
                case "dia":
                    setCommand({
                        ...command,
                        dia: checked,
                    });
                    setTurnoDiaChecked(checked);
                    break;
                case "noche":
                    setCommand({
                        ...command,
                        noche: checked,
                    });
                    setTurnoNocheChecked(checked);
                    break;
                default:
                    break;
            }
        }
    };

    const onRenderHeader = useCallback(
        () => (
            <>
                <PanelHeader
                    nameIconHeader="add"
                    textHeader={`Rosters`}
                    subTextHeader={`Agregar nuevo roster`}
                />
            </>
        ), []
    );

    const onRenderFooter = useCallback(
        () => (
            <>
                <PanelFooter
                    texto="Agregar"
                    // texto2={"Salir"}
                    disableButton={disableForm}
                    onClick={postInsertarRoster}
                    onDismiss={cerrarPanel}
                />
            </>
        ), [command, disableForm]
    );
    const onRenderFooter2 = useCallback(
        () => (
            <>
                <PanelFooter
                    texto="Salir"
                    // texto2={"Salir"}

                    onClick={cerrarPanel}
                    // onDismiss={cerrarPanel}
                    oneButton={true}
                />
            </>
        ), [command, disableForm]
    );

    const onReset = () => {
        setLoading(false);
        setMensaje("");
    }

    return (
        <Panel
            type={PanelType.medium}
            onRenderHeader={onRenderHeader}
            onRenderFooter={(!loading && mensaje == "") ? onRenderFooter : buttonSalir ? onRenderFooter2 : undefined}
            isFooterAtBottom
            isOpen={props.isOpen}
            onDismiss={cerrarPanel}
        >
            <div className="ms-Grid" dir="ltr">
                <div hidden={mensaje == ""}>
                    <MessageBarResponse
                        objetoResponse={{ codigo: status, mensaje: mensaje }}
                        close={true}
                    />
                </div>
                <div hidden={!loading}>
                    <ProgressBarLoading></ProgressBarLoading>
                </div>
                {!loading && !mensaje &&
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gridGap: "10px" }}>
                        <TextField
                            type="text"
                            label="Código de Roster:"
                            placeholder="Ingrese código"
                            autoComplete="off"
                            value={command.codigo}
                            onChange={(event, newValue) => {
                                if (newValue != null) {
                                    setCommand({ ...command, codigo: newValue })
                                }
                            }}
                        />
                        <TextField
                            type="number"
                            label="Días laborables:"
                            placeholder="Ingrese cantidad de días"
                            autoComplete="off"
                            value={command.diasLaborables ? command.diasLaborables.toString() : undefined}
                            onChange={(event, newValue) => {
                                if (newValue != null) {
                                    setCommand({ ...command, diasLaborables: Number(newValue) })
                                }
                            }}
                        />
                        <TextField
                            type="number"
                            label="Días de descanso:"
                            placeholder="Ingrese cantidad de días"
                            autoComplete="off"
                            value={command.diasDescanso ? command.diasDescanso.toString() : undefined}
                            onChange={(event, newValue) => {
                                if (newValue != null) {
                                    setCommand({ ...command, diasDescanso: Number(newValue) })
                                }
                            }}
                        />
                        <ComboBoxBase
                            title="Guardia:"
                            componentRef={comboBoxRefGuardiaProgramacion}
                            KeyUp={_onkeyUpSearchGuardiaProgramacion}
                            onClick={onClickComboGuardiaProgramacion}
                            options={dataComboGuardiaProgramacion}
                            selectedKey={command.guardiaProgramacionId}
                            onChange={(e: React.FormEvent<IComboBox>, option) => {
                                onChangeCombo(e, option, "guardia");
                            }}
                            description={true}
                        />
                        <Toggle
                            label="Turno Día"
                            onText="Si"
                            offText="No"
                            onChange={(e, v) => _onChangeToggle("dia", e, v)}
                            checked={turnoDiaChecked}
                        />

                        <Toggle
                            label="Turno Noche"
                            onText="Si"
                            offText="No"
                            onChange={(e, v) => _onChangeToggle("noche", e, v)}
                            checked={turnoNocheChecked}
                        />
                    </div>
                }
            </div>
        </Panel>
    )
}

export { PanelRosterCrear }